import type { LocaleMessageBundle } from '../../types'

export const branchMessages: LocaleMessageBundle = {
  vi: {
    'branch.model': 'Chi nhánh',
    'branch.title': 'Quản lý chi nhánh',
    'branch.fields.code': 'Mã chi nhánh',
    'branch.fields.name': 'Tên chi nhánh',
    'branch.fields.phone': 'Điện thoại',
    'branch.fields.email': 'Email',
    'branch.fields.address': 'Địa chỉ',
    'branch.fields.province': 'Tỉnh / thành',
    'branch.fields.district': 'Quận / huyện',
    'branch.fields.ward': 'Phường / xã',
    'branch.fields.status': 'Trạng thái',
    'branch.fields.isDefault': 'Mặc định',
    'branch.fields.isDefaultLocked': 'Cần chọn chi nhánh khác làm mặc định trước khi gỡ.',
    'branch.fields.sortOrder': 'Sắp xếp',
    'branch.actions.add': 'Thêm chi nhánh',
    'branch.actions.create': 'Thêm chi nhánh',
    'branch.actions.update': 'Cập nhật chi nhánh',
    'branch.actions.submitCreate': 'Tạo chi nhánh',
    'branch.actions.submitUpdate': 'Lưu thay đổi',
    'branch.actions.cancel': 'Đóng',
    'branch.actions.delete': 'Xóa',
    'branch.actions.restore': 'Khôi phục',
    'branch.actions.deleteTitle': 'Xóa chi nhánh',
    'branch.deleteConfirm': 'Bạn có chắc muốn xóa chi nhánh {name}?',
    'branch.errors.saveFailed': 'Không thể lưu chi nhánh. Vui lòng thử lại.',
    'branch.switcher.label': 'Chi nhánh',
  },
  en: {
    'branch.model': 'Branch',
    'branch.title': 'Branch management',
    'branch.fields.code': 'Branch code',
    'branch.fields.name': 'Branch name',
    'branch.fields.phone': 'Phone',
    'branch.fields.email': 'Email',
    'branch.fields.address': 'Address',
    'branch.fields.province': 'Province / city',
    'branch.fields.district': 'District',
    'branch.fields.ward': 'Ward',
    'branch.fields.status': 'Status',
    'branch.fields.isDefault': 'Default',
    'branch.fields.isDefaultLocked': 'Set another branch as default before clearing this one.',
    'branch.fields.sortOrder': 'Sort order',
    'branch.actions.add': 'Add branch',
    'branch.actions.create': 'Create branch',
    'branch.actions.update': 'Update branch',
    'branch.actions.submitCreate': 'Create branch',
    'branch.actions.submitUpdate': 'Save changes',
    'branch.actions.cancel': 'Cancel',
    'branch.actions.delete': 'Delete',
    'branch.actions.restore': 'Restore',
    'branch.actions.deleteTitle': 'Delete branch',
    'branch.deleteConfirm': 'Are you sure you want to delete branch {name}?',
    'branch.errors.saveFailed': 'Unable to save branch. Please try again.',
    'branch.switcher.label': 'Branch',
  },
}
